import React, { FC } from "react";
import AVPostPopup from "../../components/common/AVPostPopup";

interface Props {
  visibilityPermission: string;
  setShowCreatePost: any;
  Postdata: any;
  setFeedChunks: any;
  feedChunks: any;
  onEmojiClick?: (
    emojiObject: { native: string },
    isFormattedPost: boolean,
  ) => void;
  handleAddComment: any | undefined;
  handlePostComment: any | undefined;
  showAddComment: any | false;
  setShowAddComment: any | undefined;
  setCommentMedia: any | undefined;
  isHuddlePostTab: any | false;
}

const CreatePostpopup: FC<Props> = ({
  setShowCreatePost,
  Postdata,
  visibilityPermission,
  setFeedChunks,
  feedChunks,
  onEmojiClick,
  handleAddComment,
  handlePostComment,
  showAddComment,
  setShowAddComment,
  setCommentMedia,
  isHuddlePostTab,
}) => {
  return (
    <AVPostPopup
      visibilityPermission={visibilityPermission}
      Postdata={Postdata}
      setShowCreatePost={setShowCreatePost}
      type={"Create"}
      setFeedChunks={setFeedChunks}
      feedChunks={feedChunks}
      onEmojiClick={onEmojiClick}
      handleAddComment={handleAddComment}
      handlePostComment={handlePostComment}
      showAddComment={showAddComment}
      setShowAddComment={setShowAddComment}
      setCommentMedia={setCommentMedia}
      isHuddlePostTab={isHuddlePostTab}
    />
  );
};

export default CreatePostpopup;
